import { createSelector } from 'reselect';
import { RootState } from '../store.types';
import { GridItemEntities, QueryResultsState } from './models';

const selectQueryResultsState = (state: RootState): QueryResultsState => state.queryResults;

export const selectItemRequest = createSelector(
  [selectQueryResultsState],
  (state: QueryResultsState) => state ? state.itemRequest : null
);

export const selectPreviewHTML = createSelector(
  [selectQueryResultsState],
  (state: QueryResultsState) => state ? state.previewHTML : null
);

export const selectTabDataEntities = createSelector(
  [selectQueryResultsState],
  (state: QueryResultsState) => state ? state.gridItemEntities : null
);

export const selectTabItemCount = createSelector(
  [selectQueryResultsState],
  (state: QueryResultsState) => state ? state.gridItemCount : null
);

export const selectTabData = createSelector(
  [selectTabDataEntities],
  (state: GridItemEntities|null) => state ? Object.keys(state).map(id => state[parseInt(id, 10)]) : null
);

export const selectDownloading = createSelector(
  [selectQueryResultsState],
  (state: QueryResultsState) => state ? state.downloading : null
);

export const selectDownloadProgress = createSelector(
  [selectQueryResultsState],
  (state: QueryResultsState) => state ? state.downloadProgress : null
);

export const selectIdsForDownload = createSelector(
  [selectQueryResultsState],
  (state: QueryResultsState) => state? state.idsForDownload : null
);

export const selectTabLoading = createSelector(
  [selectQueryResultsState],
  (state: QueryResultsState) => state ? state.tabLoading : null
);

export const selectTabLoaded = createSelector(
  [selectQueryResultsState],
  (state: QueryResultsState) => state ? state.tabLoaded : null
);

export const selectPrevLoading = createSelector(
  [selectQueryResultsState],
  (state: QueryResultsState) => state ? state.prevLoading : null
);

export const selectPrevLoaded = createSelector(
  [selectQueryResultsState],
  (state: QueryResultsState) => state ? state.prevLoaded : null
);

export const selectQDSearchLoading = createSelector(
  [selectQueryResultsState],
  (state: QueryResultsState) => state ? state.searchLoading : false
);

export const selectQDSearchLoaded = createSelector(
  [selectQueryResultsState],
  (state: QueryResultsState) => state ? state.searchLoaded : false
);

export const selectErrMsg = createSelector(
  [selectQueryResultsState],
  (state: QueryResultsState) => state ? state.errMsg : null
);
